<template>
  <div class="latest-blogs-section">
    <div class="container">
      <div class="section-title">
            <div class="big-title">
         <span class="sub-title-shadow text-capitalize">Related</span>
        <span class="sub-title text-uppercase">Related Blogs</span>
        <h2>Read Our Related Blog Posts</h2>
      </div>
         </div>
      <div class="row justify-content-center">
        <div class="col-lg-4 col-md-6 mb-4" v-for="blog in blogs" :key="blog.slug">
          <div class="single-blog-post">
            <router-link :to="`/resource-detail/${blog.slug}`" class="d-block">
              <img :src="$backendUrl + getBlogImage(blog)" :alt="blog.image?.alternativeText || blog.title || 'Blog Post'" class="img-fluid" style="height:220px;object-fit:cover;width:100%;" />
            </router-link>
            <div class="content mt-3">
              <ul class="meta mb-2">
                <li><i class="ri-time-line"></i> {{ formatDate(blog.publishedAt || blog.updatedAt) }}</li>
              </ul>
              <h3>
                <router-link :to="`/resource-detail/${blog.slug}`">{{ blog.title }}</router-link>
              </h3>
            </div>
          </div>
        </div>
      </div>
        <div class="view-all text-center pt-2"  >
           <router-link :to="`/resources`"  class="default-btn">View all </router-link>
 </div>
    </div>

  </div>
</template>
<script setup>
import { defineProps } from 'vue';
import meanderLogo from '../../assets/images/black-logo.png';
const props = defineProps({
  blogs: {
    type: Array,
    required: true
  }
});
function formatDate(dateString) {
  if (!dateString) return '';
  return new Intl.DateTimeFormat('default', { dateStyle: 'long' }).format(new Date(dateString));
}
function getBlogImage(blog) {
  if (blog.image && blog.image.url) {
    return  blog.image.url;
  }     
  return meanderLogo;
}
  function goToResources() {
    window.location.href = "/resources";
  }
</script>
<style scoped>
.latest-blogs-section {
  background: #fff;
}
.single-blog-post {
  background: #f9f9f9;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  padding: 16px;
  transition: box-shadow 0.2s;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.single-blog-post:hover {
  box-shadow: 0 4px 16px rgba(0,0,0,0.10);
}
</style> 